// Utilitários de segurança para context switching

export const validateContextSwitching = (user) => {
  return user?.permission_level === 'super_admin'
}

export const canAccessOrganizador = (user, organizadorId) => {
  // Super admin pode acessar qualquer organizador
  if (user?.permission_level === 'super_admin') {
    return true
  }
  
  // Usuários normais só podem acessar seu próprio organizador
  return user?.organizador_id === organizadorId
}

export const sanitizeOrganizadorContext = (user, organizadorAtivo) => {
  // Se não for super admin, limpar contexto
  if (!validateContextSwitching(user)) {
    localStorage.removeItem('organizador_ativo')
    return null
  }
  
  return organizadorAtivo
}

// Interceptor para requisições com organizador_id
export const validateApiRequest = (user, params) => {
  if (params.organizador_id && !validateContextSwitching(user)) {
    throw new Error('Acesso negado: Context switching não permitido')
  }
  
  return params
}